import { GenesisElement, observable } from '@genesislcap/web-core';
import { landingTemplate as template } from './landing.template';
import { landingStyles as styles } from './landing.styles';
import { customElement } from '@genesislcap/web-core';
import {Auth} from "@genesislcap/foundation-comms";
import {Permission} from "../../pbi/constants";

@customElement({
  name: 'landing-page',
  template,
  styles
})
export class LandingPage extends GenesisElement {
  @Auth private auth: Auth;
  @observable userName: string = '';

  connectedCallback() {
    super.connectedCallback();
    // Get user information from Genesis
    const user = (window as any).foundationUser;
    if (user) {
      this.userName = user.firstName || user.username || 'User';
    }
  }

  get currentUser() {
    return this.auth.currentUser.userName;
  }

  navigateToPBI() {
    // Navigate to New Issues (PBI) application
    this.$emit("navigateToPage", "PBI");
  }

  navigateToMBM() {
    // Navigate to Liquidity Hub (MBM) application
    this.$emit("navigateToPage", "MBM");
  }

  navigateToUserManagement() {
    // Navigate to User Management application
    this.$emit("navigateToPage", "UserManagement");
  }

  isPBIEnabled(): boolean {
    // Determine if New Issues module should be enabled
    return this.auth.currentUser.hasPermission(Permission.VIEW_DEAL_LISTINGS);
  }

  isMBMEnabled(): boolean {
    // Determine if Liquidity Hub module should be enabled
    return this.auth.currentUser.hasPermission('ViewLiveActivity');
  }

  isUserManagementEnabled(): boolean {
    // Add your logic here to determine if UserManagement should be enabled
    return (
      this.auth.currentUser.hasProfile('UserAdmin') ||
      this.auth.currentUser.hasProfile('UserViewer')
    );
  }


}
